import React, { useEffect, useState } from "react";
import noImage from "../../../../../../assets/images/settings/no-image.png";
import axios from "axios";
import { ListGroup } from "react-bootstrap";
import { serverInfo } from "../../../../../../App";
import { useContext } from "react";

const AssignedGroupJuries = ({ audition_id, group }) => {
  const { imageCdnUrl } = useContext(serverInfo);
  const [juries, setJuries] = useState([]);

  useEffect(() => {
    axios
      .get(`/api/audition-admin/audition/group_juries/${audition_id}/${group}`)
      .then((res) => {
        if (res.data.status === 200) {
          setJuries(res.data.juries);
        }
      });
  }, [group]);

  return (
    <div className="mb-3">
      {juries.map((jury) => (
        <div className="d-flex  text-light fw-bold align-items-center pt-3 px-3">
          <img
            className="demoStar auditionAvatar"
            src={
              jury.user?.image !== null
                ?imageCdnUrl+jury.user?.image
                : noImage
            }
            alt=""
          />
          <div className="star-name px-3">
            <h5 className="text-warning ">
              {jury.user?.first_name} {jury.user?.last_name}{" "}
            </h5>
            <small className="text-light">
              {jury.user?.category?.name}
            </small>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AssignedGroupJuries;
